import React from 'react';
import Navbar from '../components/Navbar';
import SeoHead from '../components/SeoHead';
import Footer from '../components/Footer';

const Legal = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <SeoHead
        title="Mentions légales - PulseCIO"
        description="Mentions légales et informations administratives du service PulseCIO, plateforme SaaS de centralisation des messages professionnels."
        breadcrumb={{ name: "Mentions légales", path: "/legal" }}
      />
      <Navbar />
      <main className="flex-1 container mx-auto px-6 py-20">
        <h1 className="text-3xl font-bold mb-6 text-black dark:text-white">Mentions légales</h1>
        <div className="prose dark:prose-invert max-w-none">
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Informations légales concernant le service PulseCIO.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Éditeur</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            PulseCIO — édité et développé par Mathieu Lalande (auto-entreprise). 
            Toutes les informations publiées sur ce site relèvent de la responsabilité de l'auteur.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Statut juridique</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Statut : auto-entreprise (micro-entrepreneur). Pas de capital social à déclarer pour ce statut.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Hébergeur</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Le site est hébergé par Hostinger (https://www.hostinger.com).
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Contact</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Pour toute question, contactez-nous à{' '}
            <a href="mailto:contact@pulsecio.com" className="text-blue-600 dark:text-blue-400 hover:underline">
              contact@pulsecio.com
            </a>
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Informations administratives</h2>
          <div className="text-gray-700 dark:text-gray-300 mb-4">
            <p><strong>MONSIEUR</strong> MATHIEU LALANDE</p>
            <p><strong>SIREN :</strong> 940 937 311</p>
            <p><strong>SIRET DU SIÈGE SOCIAL :</strong> 940 937 311 00014</p>
            <p><strong>DATE DE CRÉATION :</strong> 15 février 2025</p>
            <p><strong>ACTIVITÉ (NAF / APE) :</strong> Programmation informatique - 6201Z</p>
            <p><strong>FORME JURIDIQUE :</strong> Entrepreneur individuel</p>
          </div>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Directeur de publication</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Le directeur de publication du site est Mathieu Lalande, responsable de l'édition des contenus.
          </p>

          <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
            Dernière mise à jour : 9 janvier 2026
          </p>
        </div>
      </main>
      <div className="w-full flex justify-center mt-12 mb-2">
        <a href="/" className="inline-flex items-center px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold shadow hover:bg-blue-700 transition">
          ← Retour à la page principale
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default Legal;